import styled from 'styled-components';
import { always, prop, ifElse, propEq } from 'ramda';
import { Pill } from '../pill';
import { themeColor } from '../../../theme/getters';
import { primaryText } from '../../../theme/typography';
import { media } from '../../../theme/media';
import { noTapSelection } from '../../../theme/mixins';
import { fadeInAndUpTransition } from '../../../theme/transitions';
import { FilterNames } from '../../../modules/filters/filters.constants';

const getMaxWidthByFilterNameForDesktop = ifElse(propEq('filterName', FilterNames.DATE), always(1065), always(533));

export const Dialog = styled.section`
  ${noTapSelection};
  width: 100%;
  max-width: 90%;
  background: ${themeColor('pinkWash')};
  ${fadeInAndUpTransition};

  ${media.tablet`
    max-width: ${getMaxWidthByFilterNameForDesktop}px;
  `}
`;

export const Header = styled.header`
  padding: 20px 24px 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${themeColor('middleGray')};

  ${media.tablet`
    padding: 20px 40px;
  `}
`;

export const Heading = styled.h2`
  ${primaryText};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 18px;
  line-height: 23px;
`;

export const Content = styled.section`
  position: relative;
  padding: 32px 40px 40px;
  ${prop('extraStyle')}
`;

export const ScrollContent = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 60vh;

  ${media.tablet`
    max-height: 80vh;
  `}
`;

export const Controls = styled.div`
  display: flex;
`;

export const Control = styled(Pill)`
  width: 80px;
  background: ${({ primary }) => !primary && themeColor('pinkWash')};
  padding: 11px 24px;
  margin-right: 8px;

  :last-of-type {
    margin-right: 0;
  }

  ${media.tablet`
     width: 109px;
  `}
`;
